import { t } from '../../i18n/index.js';
import { icon, escapeHtml } from '../../utils/dom.js';

// A label names only its input; the visibility button has its own accessible name.
export function authField({ name, label, type = 'text', autocomplete, hint, password = false, showPw = false, value = '', readonly = false, required = false, busy = false, placeholder = '' }) {
  const id = `auth-${name}`;
  return `<div class="auth-field">
    <label class="auth-label" for="${id}">${escapeHtml(t(label))}</label>
    <div class="auth-inputwrap">
      <span class="auth-ico" aria-hidden="true">${icon(password ? 'lock' : type === 'email' ? 'mail' : 'person', 20)}</span>
      <input id="${id}" class="auth-input" name="${name}" type="${password ? (showPw ? 'text' : 'password') : type}"
        autocomplete="${autocomplete || name}" value="${escapeHtml(value)}"
        ${type === 'email' ? 'inputmode="email" autocapitalize="none" spellcheck="false"' : ''}
        ${hint ? `aria-describedby="${id}-hint"` : ''} ${required ? 'required' : ''}
        ${readonly ? 'readonly' : ''} ${busy ? 'disabled' : ''}
        ${placeholder ? `placeholder="${escapeHtml(t(placeholder))}"` : ''} />
      ${password && name === 'password' ? `<button type="button" class="auth-eye" data-eye data-auth-focus="eye" aria-controls="${id}" aria-pressed="${showPw}" aria-label="${escapeHtml(t('auth.togglePassword'))}">${icon(showPw ? 'visibility_off' : 'visibility', 20)}</button>` : ''}
    </div>
    ${hint ? `<span id="${id}-hint" class="auth-hint">${escapeHtml(t(hint))}</span>` : ''}
  </div>`;
}

export function authError(error) {
  return error ? `<div class="auth-error" id="auth-error" role="alert" aria-atomic="true">${icon('error', 16)}<span>${escapeHtml(error.key ? t(error.key) : error)}</span></div>` : '';
}

export function authSubmit(label, busy, symbol = 'arrow_forward') {
  return `<button class="auth-submit" type="submit" data-auth-focus="submit" ${busy ? 'disabled' : ''}>
    <span class="${busy ? 'auth-spinner' : ''}" aria-hidden="true">${icon(busy ? 'progress_activity' : symbol, 20)}</span>
    <span>${escapeHtml(t(busy ? 'auth.pleaseWait' : label))}</span>
  </button>`;
}
